import React from 'react'

import { Controller } from 'react-hook-form'

import { Textarea } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, object } from 'prop-types'

function DescriptionForm({
  control,
  disabled,
}) {
  return (
    <div className="use-cases-area__description-container">
      <span className="use-cases-area__label cgt-body-base-semibold cgt-mb-4">Your comment</span>
      <Controller
        name="description"
        control={control}
        render={({ field }) => (
          <Textarea
            {...field}
            id="use-case-description"
            placeholder="Share your printing experience"
            disabled={disabled}
            maxLength={500}
            textareaClassName="use-cases-area__textarea"
            size="small"
            isPilot
          />
        )}
      />
    </div>
  )
}

DescriptionForm.propTypes = {
  control: object.isRequired,
  disabled: bool.isRequired,
}

export default DescriptionForm
